import styled from 'styled-components';

export const THead = styled.div`
  align-items: flex-end;
`;
